<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <!-- <jm-crumbs /> -->
          <el-tabs value="qcrb">
            <el-tab-pane label="前程日本文案流程" name="qcrb"></el-tab-pane>
          </el-tabs>

          <div class="searchList">
            <jm-toolbar
              show-defined-search
              customize-field-name="QcProcess"
            />
            <div class="service-area" v-if="dataTableInited">
              <div class="box-content" v-if="filterVisible('crm_money_all')">
                <label class="form-tit">服务费全款</label>
                <el-input class="jm-input220" v-model="searchData['crm_money_all']" />
              </div>
              <div class="box-content" v-if="filterVisible('course_id')">
                <label class="form-tit">申请项目</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  v-model="searchData['course_id']"
                  dict-type="course"
                  :filter="(item) => item.pid === 485"
                />
              </div>
              <div class="box-content" v-if="filterVisible('crm_cse')">
                <label class="form-tit">客服老师</label>
                <el-select
                  class="jm-input220"
                  v-model="searchData['crm_cse']"
                  placeholder="请选择"
                  clearable
                >
                  <el-option-group
                    v-for="(group, k) in customerTeacher"
                    :key="k"
                    :label="k"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.userid"
                      :label="item.truename"
                      :value="item.userid"
                    />
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content" v-if="filterVisible('same_as_leaving')">
                <label class="form-tit">同时出院生</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleYesNo"
                  v-model="searchData['same_as_leaving']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('has_apply_type')">
                <label class="form-tit">有无申请方式</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleDorm"
                  v-model="searchData['has_apply_type']"
                  dict-type="qcrb"
                />
              </div>

              <div class="box-content" v-if="filterVisible('crm_gathering')">
                <label class="form-tit">服务费首款</label>
                <el-input class="jm-input220" v-model="searchData['crm_gathering']" />
              </div>
              <div class="box-content" v-if="filterVisible('crm_star')">
                <label class="form-tit">评星等级</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  v-model="searchData['crm_star']"
                  dict-type="student"
                  name="crmStar"
                />
              </div>
              <div class="box-content" v-if="filterVisible('crm_writer')">
                <label class="form-tit">申请老师</label>
                <el-select
                  class="jm-input220"
                  v-model="searchData['crm_writer']"
                  placeholder="请选择"
                  clearable
                >
                  <el-option-group
                    v-for="(group, k) in writeTeachers"
                    :key="k"
                    :label="k"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.userid"
                      :label="item.truename"
                      :value="item.userid"
                    />
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content" v-if="filterVisible('apply_school')">
                <label class="form-tit">申请学校</label>
                <jm-school-search
                  class="jm-input220"
                  v-model="research1"
                  clearable
                  :country-id="485"
                  @change="schoolSelect"
                />
              </div>
              <div class="box-content" v-if="filterVisible('research')">
                <label class="form-tit">教授方向</label>
                <el-input class="jm-input220" v-model="searchData['research']" />
              </div>

              <div class="box-content" v-if="filterVisible('crm_final_pay')">
                <label class="form-tit">服务费尾款</label>
                <el-input class="jm-input220" v-model="searchData['crm_final_pay']" />
              </div>
              <div class="box-content" v-if="filterVisible('crm_sayer')">
                <label class="form-tit">咨询老师</label>
                <el-select
                  class="jm-input220"
                  v-model="searchData['crm_sayer']"
                  placeholder="请选择"
                  clearable
                >
                  <el-option-group
                    v-for="(group, k) in advisoryTeacher"
                    :key="k"
                    :label="k"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.userid"
                      :label="item.truename"
                      :value="item.userid"
                    />
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content" v-if="filterVisible('crm_document')">
                <label class="form-tit">文书老师</label>
                <el-select
                  class="jm-input220"
                  v-model="searchData['crm_document']"
                  placeholder="请选择"
                  clearable
                >
                  <el-option-group
                    v-for="(group, k) in documentTeacher"
                    :key="k"
                    :label="k"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.userid"
                      :label="item.truename"
                      :value="item.userid"
                    />
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content" v-if="filterVisible('org_name')">
                <label class="form-tit">申请研究科</label>
                <el-input class="jm-input220" v-model="searchData['org_name']" />
              </div>
              <div class="box-content" v-if="filterVisible('status')">
                <label class="form-tit">办理状态</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleState"
                  v-model="searchData['status']"
                  dict-type="qcrb"
                />
              </div>
            </div><!--End of Service-Area 1-->

            <div class="clearfix" />
            <div class="service-area" v-if="dataTableInited" v-permission="[44, 74, 39]">
              <div class="line"></div>

              <div class="box-content" v-if="filterVisible('write_step')">
                <label class="form-tit">报名材料收齐</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="materialStatus"
                  v-model="searchData['write_step']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_apply_notified')">
                <label class="form-tit">通知准备出愿材料</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleNotice"
                  v-model="searchData['is_apply_notified']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('apply_status')">
                <label class="form-tit">入学许可下达</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleStatus"
                  v-model="searchData['apply_status']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_zailiu_posted')">
                <label class="form-tit">在留材料邮寄</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handlePosted"
                  v-model="searchData['is_zailiu_posted']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_dormitory_apply')">
                <label class="form-tit">宿舍申请是否成功</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleYesNo"
                  v-model="searchData['is_dormitory_apply']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_resale_house')">
                <label class="form-tit">房屋是否在我公司办理</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleYesNo"
                  v-model="searchData['is_resale_house']"
                  dict-type="qcrb"
                />
              </div>

              <div class="box-content" v-if="filterVisible('apply_deadline')">
                <label class="form-tit">出愿截止日期</label>
                <el-date-picker
                  class="jm-input220"
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  v-model="searchData['apply_deadline']"
                  style="width: 100%"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_apply_posted')">
                <label class="form-tit">出愿材料邮寄</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handlePosted"
                  v-model="searchData['is_apply_posted']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('zailiu_deadline')">
                <label class="form-tit">在留截止日期</label>
                <el-date-picker
                  class="jm-input220"
                  clearable
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  v-model="searchData['zailiu_deadline']"
                  style="width: 100%"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_zailiu_received')">
                <label class="form-tit">在留材料签收</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleReceived"
                  v-model="searchData['is_zailiu_received']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_resale_visa')">
                <label class="form-tit">是否在我公司办理签证</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleYesNo"
                  v-model="searchData['is_resale_visa']"
                  dict-type="qcrb"
                />
              </div>

              <div class="box-content" v-if="filterVisible('is_apply_received')">
                <label class="form-tit">出愿材料签收</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleReceived"
                  v-model="searchData['is_apply_received']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_zailiu_notified')">
                <label class="form-tit">通知准备在留材料</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleNotice"
                  v-model="searchData['is_zailiu_notified']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('zailiu_status')">
                <label class="form-tit">在留下达</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleStatus"
                  v-model="searchData['zailiu_status']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_dormitory')">
                <label class="form-tit">有无宿舍</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleDorm"
                  v-model="searchData['is_dormitory']"
                  dict-type="qcrb"
                />
              </div>
              <div class="box-content" v-if="filterVisible('is_resale_phone')">
                <label class="form-tit">手机是否在我公司办理</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleYesNo"
                  v-model="searchData['is_resale_phone']"
                  dict-type="qcrb"
                />
              </div>
            </div><!--End of Service-Area 2-->

            <div class="clearfix" />
            <div class="service-area" v-if="dataTableInited" v-permission="[73, 46, 39]">
              <div class="line"></div>

              <div class="box-content" v-if="filterVisible('prof_name')">
                <label class="form-tit">意向教授</label>
                <el-input class="jm-input220" v-model="searchData['prof_name']" />
              </div>
              <div class="box-content" v-if="filterVisible('confirm_date')">
                <label class="form-tit">确定办理时间</label>
                <el-date-picker
                  class="jm-input220"
                  clearable
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  v-model="searchData['confirm_date']"
                  style="width: 100%"
                />
              </div>

              <div class="box-content" v-if="filterVisible('intention_date')">
                <label class="form-tit">出现意向的时间</label>
                <el-date-picker
                  class="jm-input220"
                  clearable
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  v-model="searchData['intention_date']"
                  style="width: 100%"
                />
              </div>
              <div class="box-content" v-if="filterVisible('qsp_status')">
                <label class="form-tit">跟进状态</label>
                <jm-dict-select
                  class="jm-input220"
                  clearable
                  type="dataset"
                  name="handleState"
                  v-model="searchData['qsp_status']"
                  dict-type="qcrb"
                />
              </div>
            </div><!--End of Service-Area 3-->
            <div class="clearfix" />
          </div>
          <div class="searchBottom">
            <el-button class="jm-input-common3" type="primary" @click="() => this.refresh = true">开始查询</el-button>
            <el-button class="jm-input-common3" type="default" @click="resetFields">重置</el-button>
          </div>

          <jm-tableList
            :inited.sync="dataTableInited"
            url="/index/qc_process/pagetable"
            :search-data="searchData"
            :refresh.sync="refresh"
            :span-method="spanMethod"
            :modifier="dataModifier"
          >
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="290">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'applyAdmin', hash: `#s_${scope.row.sid}`, params: { crmid: scope.row.id } }"
                  v-permission="[46, 73]"
                >申请编辑
                </router-link>
                <router-link
                  target="_blank"
                  :to="{ name: 'serviceAdmin', hash: `#s_${scope.row.sid}`, params: { crmid: scope.row.id } }"
                  v-permission="[44, 74]"
                >客服编辑
                </router-link>
                <router-link
                  target="_blank"
                  :to="{ name: 'infoManagement', hash: `#s_${scope.row.sid}`, params: { crmid: scope.row.id } }"
                  v-permission="[43, 51]"
                >基本信息编辑
                </router-link>
                <router-link
                  target="_blank"
                  :to="{ name: 'infoManagement', hash: `#s_${scope.row.sid}`, params: { crmid: scope.row.id } }"
                  v-permission="[39, 51, 73, 74]"
                >办理信息
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import {
  jmDictSelect,
  jmSchoolSearch,
  jmSchoolOrgSearch,
} from '@/components/tool/index.js';
import * as TeacherApi from '@/api/teacher.js';
import { filterVisible, formatSelectGroupData } from '@/utils/utils.js';
import qcrbPublic from './qcrbPublic.js';

const toolbar = () => import('@/components/tool/toolbar.vue');

export default {
  data() {
    return {
      writeTeachers: null,
      customerTeacher: null, // 客服
      documentTeacher: null, // 文书
      advisoryTeacher: null, // 资讯
      schoolId: 0,
      searchData: {},
      research1: '',
      userpower: '2',
      refresh: false,
      dataTableInited: false,
    };
  },
  methods: {
    filterVisible,
    tableListData(cb) {
      this.tableListDataVal = cb;
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = null;
      });
    },
    /**
     * 选取学校
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Object} school
     */
    schoolSelect(school) {
      if (school) {
        this.searchData.sh_id = school.sh_id;
        this.schoolId = +school.sh_id;
      } else {
        this.schoolId = null;
        this.searchData.sh_id = null;
      }
    },
    /**
     * 研究科选择
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Object} org [description]
     */
    selectOrg(org) {
      if (org) {
        this.searchData.org_id = org.oid;
      }
    },
    spanMethod({ row, columnIndex }) {
      if (columnIndex <= 3) {
        if (row.flag === true) {
          return {
            rowspan: row.plength,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    },
    dataModifier(data) {
      let newData = [];
      data.data.forEach((item) => {
        let plength = item.processList.length;
        for (let i = 0; i < plength; i++) {
          let process = item.processList[i];
          newData.push({
            ...item, ...process, id: item.id, sid: process.id, plength, flag: i === 0
          });
        }
      });
      data.data = newData;
      return data;
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    'jm-toolbar': toolbar,
    jmDictSelect,
    jmSchoolSearch,
    jmSchoolOrgSearch
  },
  mounted() {
    // 申请
    TeacherApi.getTeachers(46).then(({ data }) => {
      this.writeTeachers = formatSelectGroupData(data);
    });
    // 咨询
    TeacherApi.getTeachers(43).then(({ data }) => {
      this.advisoryTeacher = formatSelectGroupData(data);
    });
    // 客服
    TeacherApi.getTeachers(44).then(({ data }) => {
      this.customerTeacher = formatSelectGroupData(data);
    });
    // 文书
    TeacherApi.getTeachers(45).then(({ data }) => {
      this.documentTeacher = formatSelectGroupData(data);
    });
  },
  mixins: [qcrbPublic],
};
</script>

<style scoped>
div.line {
  width: 100%;
  height: 0;
  border-top: 1px solid #eee;
  margin-bottom: 10px;
}
</style>
